import React from 'react';
import styled from '@emotion/styled';
import { PropertyMatch, Result } from '../types';

const Details = styled.div`
  display: grid;
  grid-template-columns: 18% 16% 10% 8% 8% 8% 25%;
  grid-column-gap: 1%;
  border-bottom: 1px solid #e5e5ea;
  border-right: 1px solid #e5e5ea;
  border-left: 1px solid #e5e5ea;
  padding: 20px 16px;
  margin: 0 16px;
  cursor: pointer;
  :hover {
    background-color: #e5e5ea;
  }
`;
interface Props {
  propertyResult: Result;
  isNj:boolean;
  onPropertyClick: () => void;
}

const PropertyResults = (props: Props) => {
  return (
    <div style={{ margin: '0 auto', maxWidth: 1300 }}>
      <Details onClick={props.onPropertyClick}>
        <div style={{ fontWeight: 'bold' }}>{props.propertyResult.address}</div>
        <div style={{ maxWidth: 200 }}>
          {props.propertyResult.muniTypes.map((mt, index) => {
            const trimmed = mt?.name.trim();
            return <span>{`${index > 0 ? ', ' : ''}${trimmed}`}</span>;
          })}
        </div>
        <div>{props.propertyResult.muniTypes[2]?.swisCode || props.propertyResult.muniTypes[1]?.swisCode || props.propertyResult.swis}</div>
        {!props.isNj && <div>{props.propertyResult.property.section}</div>}
        <div>{props.propertyResult.property.block}</div>
        <div>{props.propertyResult.property.lot}</div>
        {props.isNj && <div>{props.propertyResult.property.qualifier}</div>}
        <div style={{ maxWidth: 280 }}>{props.propertyResult.owners}</div>
      </Details>
    </div>
  );
};

export default PropertyResults;
